module.exports = __webpack_public_path__ + "static/Collaboration_Studio-ed1182419a6420a2c4565d4dcce4cc6e.png";